export const CONST_VALUES = {
    PAGE: 'page'
};

export const ACCESS_VALUES = {
    Resources: "Registered Resources"
}

export const US_STATES = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "AS",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FL",
    "GA",
    "GU",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "MP",
    "OH",
    "OK",
    "OR",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "TT",
    "UT",
    "VT",
    "VA",
    "VI",
    "WA",
    "WV",
    "WI",
    "WY"
];

export enum PageNames {
    Home = "Home",
    ProgramOverview = "ProgramOverview",
    ChargingStationLocator = "ChargingStationLocator",
    ElectrificationBasics = "ElectrificationBasics",
    ElectricVehicles = "ElectricVehicles",
    ElectricVehicleSupplyEquipment = "ElectricVehicleSupplyEquipment",
    NewsAndEvents = "NewsAndEvents",
    ContactUs = "ContactUs",
    MyAccount = "MyAccount",
    PrivacyStatement = "PrivacyStatement",
    TermsOfUse = "TermsOfUse",
    Login = "Login",
    FundingSources = "FundingSources",
    VehicleCatalog = "VehicleCatalog",
    FleetEstimator = "FleetEstimator",
    CreateFleet = "CreateFleet",
    EditFleet = "EditFleet",
    AddVehicleSets = "AddVehicleSets",
    EditVehicleSet = "EditVehicleSet",
    ViewFleets = "ViewFleets",
    ViewEstimate = "ViewEstimate",
    PrintEstimate = "PrintEstimate",
    SampleFleets = "SampleFleets",
    PageNotFound = "PageNotFound"
}
